import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row } from "reactstrap";
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import SpinnerLoader from "../../../Layout/SpinnerLoader";
import Typeahead from "../../../CommonElements/TypeAhead";
import {
  Customer, Save, EditBinAccount, BillAccountNo, Area, DriversID, AccountStatus, ServiceAddress, Latitude, Longitude, BinAccount,
} from "../../../Constant";
import { editStb, editStbRole, getArea, getAreaRole, getCustomers, getCustomersRole, getDriver, getDriverRole, updateStb, updateStbRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import Transparentspinner from "../../Common/Loader/Transparentspinner";

const schema = yup.object().shape({
  customer: yup.mixed().required().label('Customer'),
  binAccnt: yup.string().required().label('Bin Account number'),
  driver: yup.mixed().required().label('Driver'),
  account: yup.mixed().required().label('Account'),
  areaName: yup.mixed().required().label('Area'),
  service: yup.string().required().label('Service Address'),
})

const StbEdit = () => {
  const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({ resolver: yupResolver(schema) });
  const [customerOption, setCustomerOption] = useState([]);
  const [driverOption, setDriverOption] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = location.search;
  const params = new URLSearchParams(searchParams);
  const param1 = params.get("id");
  const authState = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [spinnerTrans, setspinnerTrans] = useState(true);
  const [areaOption, setAreaOption] = useState([]);

  const options = [
    { value: "active", label: "Active" },
    { value: "suspended", label: "Suspend" },
    { value: "disconnected", label: "Disconnect" },
  ];

  useEffect(() => {
    getSingleCustomerData();
  }, []);

  const handleApiError = (status) => {
    if (status >= 400 && status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (status >= 500 && status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
  };

  const getSingleCustomerData = async () => {
    const apiData = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
      editStb + `?stb_id=${param1}` : editStbRole + `?stb_id=${param1}`
    );
    if (apiData.status === true) {
      const getIDSetting = apiData?.data?.customer_id;
      const singleId = apiData.data;
      setValue("binAccnt", singleId.stb_no);
      setValue("serialNo", singleId.serial_no);
      setValue("service", singleId.service_address);
      setValue("account", { value: singleId.stb_status, label: singleId.stb_status });
      setValue("latitude", singleId.latitude);
      setValue("longitude", singleId.longitude);

      const selectedOptions = await getClientUrlDataToken(authState.apiUrl,
        authState.userRole === 1 ? getCustomers : getCustomersRole
      );
      if (selectedOptions.status === true) {
        const CustomerOptions = selectedOptions.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setCustomerOption(CustomerOptions);
        const selectedCustomer = CustomerOptions.find(
          (items) => items.value === getIDSetting
        );
        setValue("customer", { value: selectedCustomer?.value, label: selectedCustomer?.label });

      } else {
        handleApiError(selectedOptions.status);
      }

      const areResponse = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getArea : getAreaRole);
      if (apiData.status === true) {
        const options = areResponse.data.map((options) => ({ value: options.id, label: options.name }));
        setAreaOption(options);

        const selectedAreaOption = options.find(
          (option) => option.value === apiData.data.area_id
        );
        setValue("areaName", { value: selectedAreaOption?.value, label: selectedAreaOption?.label });
      } else {
        handleApiError(areResponse.status);
      }

      const DriverResponse = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getDriver : getDriverRole);
      if (apiData.status === true) {
        const options = DriverResponse.data.map((options) => ({ value: options.id, label: options.user_name }));
        setDriverOption(options);

        const selectedAreaOption = options.find(
          (option) => option.value === apiData.data.driver_id
        );
        setValue("driver", { value: selectedAreaOption?.value, label: selectedAreaOption?.label });
      } else {
        handleApiError(DriverResponse.status);
      }

      setspinnerTrans(false)
    } else {
      handleApiError(apiData.status);
    }
  }

  const onSubmit = async (data) => {
    setLoading(true);
    const postRequest = {
      stb_id: param1,
      area_id: data.areaName.value,
      service_address: data.service,
      customer_id: data.customer.value,
      driver_id: data.driver.value,
      bin_account: data.binAccnt,
      latitude: data.latitude,
      longitude: data.longitude,
    };
    const editStbResponse = await postClientUrlWithToken(authState.apiUrl,
      authState.userRole === 1 ? updateStb : updateStbRole, postRequest
    );
    if (editStbResponse.status === 200) {
      if (editStbResponse.data.status === true) {
        navigate(`${process.env.PUBLIC_URL}/customers/bin`);
        toast.success(editStbResponse.data.message);
      } else {
        errors.showMessages();
        editStbResponse.data.message.map((e) => {
          toast.error(e);
        });
      }
    } else {
      handleApiError(editStbResponse.status);
    }
    setLoading(false);
  };

  return (
    <Fragment>
      {loading && <SpinnerLoader />}
      {spinnerTrans && <Transparentspinner />}
      <Breadcrumbs mainTitle={BinAccount} parent="Customers" title={BinAccount} />
      <Card>
        <CardHeader className="pb-0">
          <H3>{EditBinAccount}</H3>
        </CardHeader>
        <CardBody>
          <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
            <Row className="g-3">
              <Col md="6">
                <Label className="form-label" >
                  {Customer} <span className="requireStar">*</span>
                </Label>
                <Controller
                  name="customer"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      id="customer"
                      options={customerOption}
                      onChange={(value) => {
                        field.onChange(value);
                      }}
                      value={field.value}
                      disabled={true}
                    />
                  )}
                />
                <p className="text-danger">{errors.customer?.message}</p>
              </Col>
              <Col md="6">
                <Label className="form-label" for="binAccnt"> {BillAccountNo} <span className="requireStar">*</span></Label>
                <input className="form-control" id="binAccnt" type="text" disabled {...register("binAccnt", { required: true })}
                />
                <p className="text-danger">{errors.binAccnt?.message}</p>
              </Col>
            </Row>
            <Row className="g-3 pt-3">
              <Col md="6">
                <Label className="form-label" >
                  {Area} <span className="requireStar">*</span>
                </Label>
                <Controller
                  name="areaName"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={areaOption}
                      onChange={(value) => {
                        field.onChange(value);
                      }}
                      value={field.value}
                    />
                  )}
                />
                <p className="text-danger">{errors.areaName?.message}</p>
              </Col>
              <Col md="6">
                <Label className="form-label" > {DriversID} <span className="requireStar">*</span></Label>
                <Controller
                  name="driver"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      id="driver"
                      options={driverOption}
                      onChange={(value) => {
                        field.onChange(value);
                      }}
                      value={field.value}
                    />
                  )}
                />
                <p className="text-danger">{errors.driver?.message}</p>
              </Col>
            </Row>
            <Row className="g-3 pt-3">
              {/* <Col md="6">
                <Label className="form-label">
                  {AccountStatus}
                </Label>
                <Controller
                  name="account"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      id="account"
                      options={options}
                      onChange={(value) => {
                        field.onChange(value);
                      }}
                      value={field.value}
                    />
                  )}
                />
              </Col> */}
              <Col md="6">
                <Label className="form-label" for="service">{ServiceAddress} <span className="requireStar">*</span></Label>
                <textarea className="form-control" id="service" type="text" {...register("service", { required: true })} />
                <p className="text-danger">{errors.service?.message}</p>
              </Col>
            </Row>
            <h3 className="mt-3">Bin Location</h3>
            <Row className="g-3 pt-3">
              <Col md="6">
                <Label className="form-label" for="latitude">{Latitude}</Label>
                <input className="form-control" id="latitude" type="text" {...register("latitude")} />
                {/* <p className="text-danger">{errors.serialNo?.message}</p> */}
              </Col>
              <Col md="6">
                <Label className="form-label" for="longitude">{Longitude}</Label>
                <input className="form-control" id="longitude" type="text" {...register("longitude")} />
                {/* <p className="text-danger">{errors.serialNo?.message}</p> */}
              </Col>
            </Row>
            <FormGroup></FormGroup>
            <div className="d-flex justify-content-center mt-3 gap-2">
              <Btn attrBtn={{ color: "primary" }} type="submit">
                {Save}
              </Btn>
              <Link to="/customers/bin" className="btn btn-light" type="button">
                Cancel
              </Link>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Fragment >
  );
};
export default StbEdit;
